import React from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import Logo from "assets/logo.svg?react";
import { MdArrowForward, MdPlayArrow } from "react-icons/md";
import { RiCheckboxCircleLine } from "react-icons/ri";

import ContainedButton from "components/layout/form/containedButton";
import Loading from "components/layout/loading";
import Stepper from "components/layout/Stepper";
import { useAdesaoEmail } from "features/adesao-email/hooks/useAdesaoEmail";

import {
  Body,
  ButtonContainer,
  Container,
  Content,
  HeaderContainer,
  Section,
  SideBanner,
  SuccessContainer,
} from "./styles";

const AdesaoEmailPage = (): JSX.Element => {
  const { emailState, errorState, loading, steppers } = useAdesaoEmail();

  return (
    <Container>
      <SideBanner>
        <Link to="/">
          <Logo aria-label="Logo da Ultragaz" />
        </Link>
        <Stepper
          activated={8}
          errorState={errorState}
          steppers={steppers}
          scrollToEnd={false}
        />
      </SideBanner>
      <Content>
        <Body>
          <Section>
            <HeaderContainer>
              <span>
                <MdPlayArrow />
                &nbsp;&nbsp;Primeiro Acesso
              </span>
              <h1>{emailState.title}</h1>
              <h2>{emailState.subTitle}</h2>
            </HeaderContainer>

            <SuccessContainer errorState={errorState}>
              {!loading &&
                (!errorState ? (
                  <RiCheckboxCircleLine size={60} />
                ) : (
                  <IoMdCloseCircle size={60} />
                ))}
              <p>{emailState.text}</p>
            </SuccessContainer>

            <ButtonContainer>
              <Link to="/">
                <ContainedButton
                  color="#4EC937"
                  TrailingIcon={MdArrowForward}
                  propsTrailingIcon={{ size: 20 }}
                >
                  Acesse o portal
                </ContainedButton>
              </Link>
            </ButtonContainer>
          </Section>
        </Body>
      </Content>
      {loading && <Loading />}
    </Container>
  );
};

export default AdesaoEmailPage;
